/** Раздел словаря «auth»: вход и регистрация (ui/auth/LoginPage.tsx), значки провайдеров (ui/auth/ProviderIcon.tsx). */
export const auth = {
  lead: 'Прогноз движения скрытого индекса из трёх акций S&P 500. Сначала — только график, затем шкала, и лишь в последнем круге — состав.',
  point1b: '4–8 игроков',
  point1: 'за столом, три круга ставок по минуте',
  point2b: 'Проверяемый расчёт:',
  point2: 'подписанный пакет с котировками и проводками',
  point3b: 'История и статистика',
  point3: 'всех ваших розыгрышей в профиле',
  demo: 'Демо: при регистрации начисляется {amount|cr} игровых кредитов. Реальных денег нет.',
  tabLogin: 'Вход',
  tabRegister: 'Регистрация',
  login: 'Логин',
  loginPh: 'латиница, цифры, . _ -',
  name: 'Имя за столом',
  namePh: 'например, Ирина',
  password: 'Пароль',
  passwordHint: 'не короче 8 символов, буквы и цифры',
  password2: 'Пароль ещё раз',
  mismatch: 'пароли не совпадают',
  submitLogin: 'Войти',
  submitRegister: 'Зарегистрироваться',
  or: 'или через',
  created: 'Учётная запись создана. Имя за столом можно изменить в профиле.',
  linked: '{provider}: учётная запись привязана к профилю',
  failed: 'вход не выполнен',
  'provider.yandex': 'Яндекс',
  'mark.yandex': 'Я',
};
